export default __webpack_public_path__ + "static/media/head-start.c7127c72.jpeg";